import {NgModule} from "@angular/core";
import {IonicModule} from "@ionic/angular";
import {CommonModule} from "@angular/common";
import {ScrollbarThemeDirective} from "./scrollbar-theme/scrollbar-theme.directive";
import { AutoModeDirective } from "./auto-mode/auto-mode.directive";

@NgModule({
  imports: [
    IonicModule,
    CommonModule
  ],
  declarations: [
    ScrollbarThemeDirective,
    AutoModeDirective,
  ],
  exports: [
    ScrollbarThemeDirective,
    AutoModeDirective,
  ]
})

export class DirectivesModule{}
